import { CustomButton } from 'components/ui'
import React, { useState } from 'react'
import { Tooltip } from 'react-tooltip'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import Modal from 'components/ui/Modal/Modal'

const DeleteUserProyectoButton = ({ user = null, handleDeleteUser = null }) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false)

  const handleModal = () => {
    setShowConfirmModal(!showConfirmModal)
  }

  const handleOnClick = () => {
    if (!user || !handleDeleteUser) return
    handleDeleteUser(user)
  }

  return (
    <>
      <div className="delete-user-button-proyecto-container">
        <CustomButton
          type="light"
          className="btn-sxm delete-user-project"
          onClick={handleModal}
        >
          <DeleteOutlineIcon sx={{ fontSize: '2rem' }} />
        </CustomButton>
      </div>
      <Tooltip
        anchorSelect=".delete-user-project"
        style={{
          fontSize: '9px',
        }}
      >
        Eliminar usuario
      </Tooltip>

      {showConfirmModal && (
        <Modal>
          <h2 className="title-modal-add-user-delete">Eliminar usuario</h2>
          <h2>
            ¿Esta seguro que desea eliminar a:
            <span className="delete-user-button-modal-name">
              {' (' + user?.email + ')'}
            </span>
            ?
          </h2>
          <div className="delete-user-button-modal-buttons">
            <CustomButton className="btn-l" type="light" onClick={handleModal}>
              Cancelar
            </CustomButton>
            <CustomButton className="btn-l" onClick={handleOnClick}>
              Confirmar
            </CustomButton>
          </div>
        </Modal>
      )}
    </>
  )
}

export default DeleteUserProyectoButton
